<template>
  <div class="">
    <v-card class="card-r no-shadow transparent mt-2">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout wrap row>
          <v-flex lg12 xs12 md6 class="">
            <v-alert
              :value="true"
              v-if="alertType"
              :type="alertType"
            >
              {{msg}}
            </v-alert>
          </v-flex>
          <v-flex lg6 xs12 md6 class="">
            <v-autocomplete
              prepend-icon="fas fa-graduation-cap"
              :items="studentsList"
              item-text="name"
              item-value="id"
              solo
              @input="filterPackage(selectedStudent)"
              v-model="selectedStudent"
              class="ma-0 white w-100"
              label="Select Student"
              placeholder="Type student Name">
            </v-autocomplete>
          </v-flex>
          <div v-if="noPackageMsg" style="color:white;background-color:red;padding:5px;">
            {{noPackageMsg}}
          </div>
          <v-flex lg6 xs12 md6 class="">
            <v-select
              :items="studentPackages"
              item-text="packageName"
              item-value="package_id"
              v-model="selectedPackage"
              solo
              @input="filterModule(selectedPackage)"
              placeholder="Select Package"
              prepend-icon="fas fa-circle"
              class="ma-0 white w-100"
            >
            </v-select>
          </v-flex>
          <v-alert v-if="noModules" type="info" :value=true> There are no modules for booking </v-alert>
          <v-flex lg6 xs12 md6 class="">
            <v-select
              :items="studentModules"
              item-text="name"
              item-value="id"
              solo
              v-model="selectedModule"
              @input="setClassDetails(selectedModule,selectedPackage,selectedStudent)"
              placeholder="Select Module"
              prepend-icon="fas fa-circle"
              class="ma-0 white w-100"
            >
            </v-select>
          </v-flex>

          <v-flex lg6 xs12 class="">
            <v-menu
              ref="menu1"
              v-model="birthday"
              :close-on-content-click="false"
              lazy
              full-width
              persistent
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="dob"
                class=""
                label="Select Date"
                persistent-hint
                value="John Doe"
                solo
                placeholder="dd/mm/yyyy"
              ></v-text-field>
              <v-date-picker  v-model="dob" no-title scrollable :events="arrayEvents" @input="GetTime(dob)">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="birthday = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="setdate(dob)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex lg6 xs12 class="">
            <v-select
              v-model="selectedTime"
              :items="timeslot"
              item-text="time_from"
              item-value="id"
              class="input-group--focused w-100"
              placeholder="select your time"
              solo
            ></v-select>
          </v-flex>
          <v-flex lg112 xs12 v-if="!loading">
            <v-btn @click="AddStudent()" larg depressed class="no-shadow card-r text-white h-50p w-100 ma-0" color="primary darken-2">Book Class</v-btn>
          </v-flex>
          <v-flex center="text-xs-center" lg112 xs12 v-if="loading">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>
<script>
  /* eslint-disable */
  import HotelDatePicker from 'vue-hotel-datepicker'
  import api from "@/utils/backend-api"
  export default {
    data() {
      return {
        menu1: '',
        dob: "",
        model:false,
        birthday: false,
        timeselect: "",
        yourValue: "",
        whats_app: ['Student Name 1 ', 'Student Name 2' , 'Student Name 3' , 'Student Name 4' , 'Student Name 5' , 'Student Name 6' , 'Student Name 7'],
        timeslot: ["07:00 am", "08:00 am", "09:00 am", "10:00 am", "11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm"],
        selectedStudent:'',
        studentPackages:[],
        selectedPackage:'',
        studentModules:[],
        selectedModule:'',
        studentTime:[],
        arrayEvents:[],
        selectedTime:'',
        alertType:'',
        msg:'',
        selectedBooking:'',
        noPackageMsg:'',
        studentsList:[],
        noModules:false,
        loading:false

      }
    },
    created:function(){
      let teacherId=this.$route.params.id
      let self=this
      api.postData('admin/teacher_students',{teacher_id:teacherId})
      .then(res=>{
        // self.studentsList.push(res.data[0].active_students)
        // let studentList={...res.data[0].active_students,...res.data[0].pending_students}
        let active=res.data[0].active_students
        let pending=res.data[0].pending_students
        self.studentsList=active.concat(pending)
      }).catch(err=>{

      })
    },
    methods: {
      AddStudent(){
          let self=this
          this.loading=true
          const postData={
              student_id:this.selectedStudent,
              package_id:this.selectedPackage,
              module_id:this.selectedModule,
              teacher_bookings_id:this.selectedTime
          }
          api.postData('admin/student_class/book',postData)
          .then(res=>{
              if(res.status==201){
                self.alertType="success"
                self.msg="Successfully Added"
                self.loading=false
                // setTimeout(()=>{
                //   router.push('/teacherprofile/'+self.teacherId+'#calender')
                // },500);
              }else if(res.status==200){
                self.alertType="error"
                self.msg=res.data.error.message
                self.loading=false
                // this.msg="Failed"
              }
          }).catch(err=>{
            this.alertType="error"
            self.loading=false
            // debugger
            try{
              if(res.status==200){
                  self.alertType="error"
                  self.msg=res.data.error.message
              }else{
                self.msg="Failed"
              }
            }catch(ex){
                self.alertType="error"
                self.msg="Failed to book"
            }
            // debugger
          })
      },
      setdate(value) {
        console.log(value)
        // this.$refs.menu1.save(value)
        this.dob = value
        this.birthday = false

      },
      filterPackage(selectedStudent){
          this.studentPackages=[]
          console.log(selectedStudent)
          api.getData('admin/student_package/'+selectedStudent)
          .then(res=>{
            // debugger
            if(res.status==200){
              // console.log(res.data)
              // debugger
                res.data.forEach((element,index)=>{
                    let Data={
                        packageName:element.packages.name,
                        package_id:element.package_id,
                        // classDetails:element.class_details
                    }
                    console.log(Data)
                    this.studentPackages.push(Data)
                })
                // let Data={
                //   bookedPackages:res.data.booked_package
                // }
            }
          }).catch(err=>{
              this.noPackageMsg="No more packages bought to book class"
          })
      },
      filterModule(selectedPackage){
        // console.log(selectedPackage)
        let moduleList=[]
        let Data={
          student_id:this.selectedStudent,
          package_id:selectedPackage
        }

        let self=this
        api.postData('admin/student_class',Data)
        .then(res=>{
          if(res.status==200){
            moduleList=res.data.non_booked_modules
            self.studentModules=res.data.non_booked_modules
            if(self.studentModules.length==0){
              self.noModules=true
            }else{
              self.noModules=false
            }
          }

          // moduleList.forEach(element=>{
          //   if(element.package_id==selectedPackage){
          //     // let modules=element.classDetails.non_booked_modules
          //     modules.forEach(element=>{
          //       console.log(element)
          //       self.studentModules.push(element)
          //     })
          //   }
          // })
        })

        // let self=this

      },
      setClassDetails(moduleId,packageId,studentId){
          this.loading1=true
          this.selectedClassId=moduleId
          this.selectedClassPackageId=packageId
          // this.selectedClass=className
          this.dob=''
          this.msg=false
          this.msgText=""
          this.alertType=""
          this.loading11=true
          this.arrayEvents=[]

          this.timeslot=[]
          let data={
            'student_id':studentId,
            'module_id':moduleId,
            'package_id':packageId
          }
          try{
            // api.postData("teacher/getTime",data)
            api.postData("admin/student_class/get_time",data)
            // http://127.0.0.1:8000/api/admin/student_class/get_time
            .then(res=>{
              // console.log(res)
              if(res.status==204){
                      this.loading1=false
                      this.msgText="No time for booking this module"
                      this.alertType="error"
                      this.msg=true
              }else if(res.status==203){
                      this.loading1=false
                      this.msgText="Not buy this package."
                      this.alertType="error"
                      this.msg=true
              }else if(res.status==200){
                  setTimeout(() => {
                      this.teacherTime=res.data
                      // console.log(res.data)

                      this.loading1=false
                      this.alertType=""
                      this.msgText=""
                      this.msg=false
                      this.arrayEvents=[]
                      let arrayEvents=[]
                      const response=res.data
                      for(var x=0;x<response.times.length;x++){
                        for(var y=0;y<response.times[x].length;y++){
                          var date=response.times[x][y].date
                            arrayEvents.push(date)
                        }
                      }
                      this.arrayEvents = arrayEvents
                      this.loading1=false
                  }, 500);
              }else{
                this.loading1=false
                this.alertType="error"
                this.msg="No time for booking this module"
              }
              // console.log()
            }).catch(err=>{
                this.loading1=false
                this.alertType="error"
                this.msg="No time for booking this module"
            })

          }catch(e){
            this.loading1=false
            this.alertType="error"
            this.msg="Error"
          }

      },
      GetTime(selectedDate){
        console.log(selectedDate);
        this.loading1=true

        this.timeslot=''
        var time=[];
        try{
          for(var x=0;x<this.teacherTime.times.length;x++){
              for(var y=0;y<this.teacherTime.times[x].length;y++){
                if(this.teacherTime.times[x][y].date==selectedDate){
                  var Data={
                    "time_from":this.teacherTime.times[x][y].time_from,
                    "id":this.teacherTime.times[x][y].id
                  }
                time.push(Data)
                }
              }
          }
          this.timeslot=time
          this.loading1=false

        }catch(e){
          this.loading1=false

        }
      }
    },
    components:{
      HotelDatePicker
    }
  }
</script>
<style>
  .datepicker__input {
    -webkit-appearance: none !important;
  }
  .datepicker__close-button {
    top: 10px!important;
    font-weight: unset!important;
    font-size: 30px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/test/FreeSlots.vue